import {
  groupingColumnList,
  planTypeList,
} from '../components/ClaimGroupingParameter';
import * as TYPES from './actionTypes';

const initialCGPState = {
  CGPSearchValues: {
    planType: '',
    rebateProgramCd: '-1',
    quarter: '',
    groupingColumn: groupingColumnList[0].value,
  },
  errorMessages: [],
  successMessages: [],
  rebateProgramCode: {},
  defaultQtrRIC: {},
  stortedGroupingColumns: [],
};

const initialCGPDetailState = {
  detailErrorMessages: [],
  detailSuccessMessages: [],
  showAllHistory: false,
  tableAdd: false,
  tableEdit: false,
  tableEditedData: [],
  detailTableData: [],
  validateTrigger: false,
  deleteRowIndex:-1
};

const initilaState = {
  ...JSON.parse(JSON.stringify(initialCGPState)),
  ...JSON.parse(JSON.stringify(initialCGPDetailState)),
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case TYPES.SET_LOADING_SPINNER:
      return {};
    case TYPES.SET_CGP_SEARCH_VALUES:
      return { ...state, CGPSearchValues: action.payload };
    case TYPES.SET_ERROR_MESSAGES:
      return { ...state, errorMessages: action.payload };
    case TYPES.SET_SUCCESS_MESSAGES:
      return { ...state, successMessages: action.payload };
    case TYPES.GET_ALL_REBATE_PROGRAMS_CGPS: {
      return { ...state, rebateProgramCode: action.payload };
    }
    case TYPES.GET_DETAIL_TABLE_DATA: {
      return { ...state, detailTableData: action.payload };
    }
    case TYPES.SET_DEFAULT_QTR: {
      return { ...state, defaultQtrRIC: action.payload };
    }
    case TYPES.SET_STORED_GROUPING_COLUMNS: {
      return { ...state, stortedGroupingColumns: action.payload };
    }
    case TYPES.SET_DETAIL_ERROR_MESSAGES: {
      return { ...state, detailErrorMessages: action.payload };
    }
    case TYPES.SET_DETAIL_SUCCESS_MESSAGES: {
      return { ...state, detailSuccessMessages: action.payload };
    }
    case TYPES.SET_SHOW_ALL_HISTORY: {
      return { ...state, showAllHistory: action.payload };
    }
    case TYPES.SET_TABLE_ADD: {
      return { ...state, tableAdd: action.payload };
    }
    case TYPES.SET_TABLE_EDIT: {
      return { ...state, tableEdit: action.payload };
    }
    case TYPES.SET_TABLE_EDITED_DATA: {
      return { ...state, tableEditedData: action.payload };
    }
    case TYPES.SET_VALIDATE_TRIGGER: {
      return { ...state, validateTrigger: action.payload };
    }
    case TYPES.RESET_CGP_STORE:
      return { ...initilaState };
    case TYPES.RESET_REQUEST_CGP_STORE: {
      return { ...state, ...JSON.parse(JSON.stringify(initialCGPState)) };
    }
    case TYPES.RESET_CGP_DETAIL_STORE: {
      return { ...state, ...JSON.parse(JSON.stringify(initialCGPDetailState)) };
    }
    case TYPES.DELETE_ROW_INDEX: {
      return { ...state, deleteRowIndex: action.payload}
    }
    default:
      return state;
  }
};

export default reducer;
